import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { TranslateService } from '@ngx-translate/core';

export interface IConfiguration {
	production: boolean;
	apiUrl: string;
	buildNumber: number;
	environment: string;
	sentryEnabled: boolean;
	sentryNomeProgetto: string;
	sentryDsn: string;
	openTelemetryEnabled: boolean;
	openTelemetryApiUrl: string;
	openTelemetryServiceName: string;
	openTelemetryAttributes: string;
	destinatatrioInvioEmailSegnalazioniErrore: string;
	oggettoInvioEmailSegnalazioniErrore: string;
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
	protected _configuration!: IConfiguration;

	constructor(
		private apiService: ApiService,
		private auth: AuthService,
		private translate: TranslateService,
	) {}

	get configuration(): IConfiguration {
		return this._configuration;
	}

	load(http: HttpClient) {
		return http.get('assets/environment/environment.json').pipe(
			map((response: any) => {
				this._configuration = response as IConfiguration;
				return this.configuration;
			}),
		);
	}

	initLingua(): Promise<void> {
		return new Promise((resolve, reject) => {
			this.apiService.elencoLingue().subscribe({
				next: (elenco: any[]) => {
					localStorage.setItem('elencoLingue', JSON.stringify(elenco));

					const linguaSalvata = this.auth.getLingua();
					const linguaBrowser = navigator.language.split('-')[0];
					const linguaDefault = elenco.find((el) => el.default)?.languageCode.toLowerCase() ?? 'it';

					const linguaToSet = linguaSalvata ? linguaSalvata : linguaBrowser || linguaDefault;

					this.translate.setDefaultLang(linguaToSet);
					this.translate.use(linguaToSet).subscribe({
						next: () => {
							this.auth.setLingua(linguaToSet);
							resolve();
						},
						error: (err) => reject(err),
					});
				},
				error: (err) => reject(err),
			});
		});
	}
}
